import { CreateElement, VNode, VNodeData } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ClTypography from '../ClTypography';

@Component({
  components: {
    ClTypography
  }
})
export default class ClFormLabel extends Vue {
  @Prop({
    type: String,
    default: 'cl-typography'
  })
  public component!: string;

  @Prop(Boolean)
  public error!: boolean;

  @Prop(Boolean)
  public noWrap!: boolean;

  public render(h: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'cl-form-label': true,
        'cl-form-label--nowrap': this.noWrap,
        'cl-form-label--error': this.error
      },
      props: {}
    };

    if (this.component === 'cl-typography') {
      data.props = {
        variant: 'body1',
        component: 'label'
      };
    }

    return h(this.component, data, this.$slots.default);
  }
}
